<template>
    <div>
        <BreadCrumb class="bread" :breads="['监测柜管理','点位管理']"></BreadCrumb>
        <div class="wrap">
            <div class="header">
                <span class="nameFt">点位管理</span>
            </div>
            <div class="submit-form">
                <el-form :model="search" :inline="true" size="small" label-width="80px">
                    <div class="submit-form__search">
                        <el-form-item label="点位名称">
                            <el-input v-model="search.point_name" size="small" placeholder="请输入点位名称"></el-input>
                        </el-form-item>
                    </div>
                    <div class="submit-form__operate">
                        <el-form-item>
                            <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
                            <el-button class="queryBtn" size="small" @click="reset">重置</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="operate-con">
                <el-button size="small" @click="openAdd" v-show="$store.getters.authority({name:'pointManage',type:'add'})">新增</el-button>
            </div>
            <div class="table-con">
                <el-table :data='tableList' stripe id="MainTables" style="width: 100%" v-loading="loading">
                    <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
                    <el-table-column prop="point_name" label="点位名称" align="center">
                    </el-table-column>
                    <el-table-column prop="sub_region" label="区域名称" align="center">
                    </el-table-column>
                    <el-table-column prop="region" label="大区名称" align="center">
                    </el-table-column>
                    <el-table-column prop="created_at" label="创建时间" align="center">
                    </el-table-column>
                    <el-table-column prop="start" label="操作" align="center" width="260" v-if="!printVisible">
                        <template slot-scope="scope">
                      <el-button size="small" type="primary" @click="modify(scope.row)" v-show="$store.getters.authority({name:'pointManage',type:'update'})">修改</el-button>
                      <el-button size="small" title="删除商品" @click="removeClick(scope.row)" v-show="$store.getters.authority({name:'pointManage',type:'delete'})">删除 </el-button>
          </template>
          </el-table-column>
        </el-table>
        <div class="paginationWrap">
          <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :layout="pageLayout" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog class="dialogMY" :visible.sync="showDialog" width="30%" center>
      <div slot="title">
        <i class="el-icon-warning"></i>
      </div>
      <div class="Main">
        <div class="infoOne">确定要删除吗？</div>
        <div class="infoTwo">你将无法恢复这条数据！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="danger" @click="remove">删 除</el-button>
      </span>
    </el-dialog>
    <SimplePrint node="MainTables" :tableList="tableList" :show="printVisible" @close="closePrint"></SimplePrint>
     <SimpleFindPointDialog ref="SimplePointDialog" @emitConfirm="emitConfirm"></SimpleFindPointDialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import SimplePrint from "@/components/SimplePrint";
import SimpleFindPointDialog from "@/components/mengniu/SimpleFindPointDialog"
import apis from "@/config/apis";
import alert from "@/plugins/alert";
import {
    download
} from "@/plugins/util";
import listMixin from "@/mixins/list";
export default {
    name: "PointManagement",
    mixins: [listMixin],
    data() {
        return {
            //  RempageIndex:1,
            Rem: 1,
            search: {},
            showDialog: false,
            removeData: "",
            row_id: "",
            is_sale: "",
            printVisible: false
        };
    },
    created() {
        this.search = Object.assign(this.search, this.$route.query);
        this.getData();
    },
    methods: {
        /*导出*/
        outDown() {
            let url = `${apis.exportPoint}`;
            download(this, url, "点位.xls");
        },
        openAdd() {
            this.$refs.SimplePointDialog.addshow({
                title: "新增点位"
            });
        },
        emitConfirm(){
            this.getData();
        },

        openPrint() {
            this.printVisible = true;
        },
        closePrint() {
            this.printVisible = false;
        },
        examine(row) {
            this.$router.push({
                path: "/index/checkpoint",
                query: {
                    id: row.id
                },
                params: this.$route.query
            });
        },
        modify(row) {
            this.$refs.SimplePointDialog.modifyshow({
                id: row.id,
                region_name: row.sub_region,
                large_name: row.region,
                point_name:row.point_name,
                title: "修改点位"
            });
        },
        searchForm() {
            this.search.page_index = 1;
            this.getData();
        },
        getData() {
            this.getTableData(apis.point, "get", this.search);
        },
        reset() {
            this.search = {};
            this.search.page_index = 1;
            this.searchForm();
        },
           removeClick(row) {
            this.row_id = row.id;
            alert.deleteAlert().then(next => {
                this.$axios.delete(apis.deletepoint+this.row_id+'/delete')
                    .then(res => {
                        if (res.data.code === 200) {
                            this.searchForm();
                             this.$message({
                                  message: '删除成功',
                                  type: 'success'
                                 });
                                 this.getData();
                        } else {
                              this.$message({
                                  message: res.data.msg,
                                  type: 'error'
                                 });
                        }
                    });
            });
        },
        // removeClick(row) {
        //     this.row_id = row.id;
        //     this.showDialog = true;
        // },
        remove() {
            let url = `${apis.Delpoint}`;
            let jsondata = {
                id: this.row_id
            };
            this.$axios.post(url, jsondata).then(data => {
                let datas = data.data;
                let {
                    code,
                    msg
                } = datas;
                if (code === 200) {
                    this.$message({
                        message: msg,
                        type: "success"
                    });
                    this.searchForm();
                    this.showDialog = false;
                } else {
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                    this.showDialog = false;
                }
            });
        }
    },
    components: {
        BreadCrumb,
        SimplePrint,
        SimpleFindPointDialog
    }
};
</script>

<style lang="scss" scoped>
/*弹窗*/

.el-icon-warning {
    color: #e6a23c;
    font-size: 60px;
}

.Main {
    text-align: center;
    .infoOne {
        font-size: 28px;
        line-height: normal;
    }
    .infoTwo {
        padding-top: 10px;
        font-size: 14px;
    }
}
</style>